import styled from 'styled-components';

const HorizontalScrollContainer = styled('div')`
  overflow-x: auto;
  width: 100%;
  height: 100%;
`;

export default HorizontalScrollContainer;
